export default "__VITE_ASSET__BQvxcDKW__"